<div class="row">
	<div class="col-12 col-md-6 mx-auto">
		<lib-login-form></lib-login-form>

		<span class="me-1">
			{{ 'login.forgot-password' | translate }}
		</span>
		<a
			class="forgot-password"
			[href]="forgotPwdUrl">
			{{ 'login.forgot-password.reset' | translate }}
		</a>

		<span class="login-noaccount me-1">{{ 'login.no-account' | translate }}</span>
		<a
			class="btn-signup mt-3"
			[href]="signupUrl">
			{{ 'login.signup' | translate }}
		</a>
	</div>
</div>
